var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-content-container',[(_vm.pictureController.file)?_c('picture-viewer',{attrs:{"value":_vm.value,"canEdit":true,"mode":"edit"}}):_c('p-upload-dropzone',{attrs:{"type":'picture',"image":require('../background_empty.svg')},on:{"file-uploaded":_vm.uploadFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }